import React from 'react';
import { useSnackbar } from 'notistack';
import Fetch from '~/fetch';

export const withFetch = (Component) => {
    const fetch = new Fetch();

    const get = (url, abortController) => fetch.get(url, abortController);
    const post = (url, data, abortController) => fetch.post(url, data, abortController);
    const put = (url, data, abortController) => fetch.put(url, data, abortController);
    const patch = (url, data, abortController) => fetch.patch(url, data, abortController);
    const _delete = (url, data, abortController) => fetch.delete(url, data, abortController);

    const hoc = (props) => {
        const { enqueueSnackbar } = useSnackbar();

        const wrapper = (f) => function(url, data, abortController) {
            return f(...arguments).then(({ok, data}) => {
                if (!ok) {
                    if (data.detail) {
                        enqueueSnackbar(data.detail, {variant: 'error'});
                    }
                    // noinspection JSUnresolvedVariable
                    if (data.non_field_errors) {
                        enqueueSnackbar(data.non_field_errors[0], {variant: 'error'});
                    }
                }
                return {ok: ok, data: data};
            });
        };

        return <Component {...props} fetch={{
            get: wrapper(get),
            post: wrapper(post),
            put: wrapper(put),
            patch: wrapper(patch),
            delete: wrapper(_delete),
        }}/>;
    };
    hoc.displayName = 'withFetch';
    return hoc;
};
